import React from "react";
import Footer from "../../components/Landing/Footer/Footer";
// import Header from "../../components/Landing/Header/Header";
import Hero from "../../components/Landing/Hero/Hero";
// import Box from "../../components/Landing/box/Box";
import UpButton from '../../components/UpButton';
//------------------------------------------------
// import Accordion from '../../components/Landing/Accordion';
// import Video from '../../components/Landing/Video';
// import HeaderSlider from '../../components/Landing/HeaderSlider';
import SubServPart from '../../components/Landing/SubServPart' ;
import OurClients from '../../components/Landing/OurClients' ;
// import Slider from '../../components/Slider';
import Form from '../../components/Landing/Form';
import Frame from '../../components/Landing/Frame'
import mill_map from '../../assets/new-banners/map.png'
import {products_last_part_2} from '../../Data/product_new' ;
//=============================================
import SubServ from '../../components/Landing/SubServ' ;
import { productsLnding } from '../../Data/products';
// import { products_2 } from '../../Data/products';
// import { products_3 } from '../../Data/products';
// import { products_4 } from '../../Data/products';
// import { products_5 } from '../../Data/products';

//============================================
import styles from "./Landing.module.scss";
// import { GoDotFill } from "react-icons/go";
import { Helmet } from "react-helmet";
import certificate_1 from '../../assets/certificates (1).jpg';
import certificate_2 from '../../assets/certificates (2).jpg';
// import certificate_3 from '../../assets/certificates (3).jpg';
import certificate_5 from '../../assets/certificates (5).png';
import certificate_4 from '../../assets/certificates (4).png';
//------------------------
import { LiaCertificateSolid } from "react-icons/lia";
import { Link } from "react-router-dom";
import millensys_profile from '../../assets/PDF/millensys_profile.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMedal } from '@fortawesome/free-solid-svg-icons'
import { GoDotFill } from "react-icons/go";
//==
const Landing = ({scroll}) => {
  return (
    <div>
      <Helmet>
        <title>Millensys - Landing</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        {/* <Header /> */}
        <Hero />
        {/* <Frame fImg ={mill_map} /> */}

        {/* <SubServPart products={products_last_part_2} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/> */}
        {/* {---------------------------------------------------------------------------------------------} */}
        <div className={styles["certification_container"]}>
          <div className={styles["title"]}>
            <h3>
            <span>MILLENSYS,</span>Technology for a Healthier Globe
            </h3>
            <h4>
            <LiaCertificateSolid  className={styles.iconImg} />
            certified with the multiple quality certificates e.g. 
          <div className={styles.certification}>
            <Link  className={styles.box}><img src={certificate_1} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_2} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_4} alt="quality certificates" loading="lazy" /></Link>
            <Link  className={styles.box}><img src={certificate_5} alt="quality certificates" loading="lazy" /></Link>
          </div>
            </h4>
            <h4>
            <FontAwesomeIcon icon={faMedal} /> | GET TO KNOW MORE ABOUT US 
            <a href={millensys_profile} download className={styles.product_list}>
              <GoDotFill className={styles.product__list_bullet} /> MILLENSYS
            </a>
            </h4>
          </div>
        </div>
        <Frame fImg ={mill_map} />

        <SubServPart products={products_last_part_2}/>
        <OurClients/>
        {/* <HeaderSlider/> */}
        {/* <Box/> */}
        {/* <Accordion/> */}
        {/* <Slider/>  */}
        {/* <Video/> */}
        <SubServ products={productsLnding}/>
        <Form/>       
        <Footer />
      </div>
    </div>
  );
};

export default Landing;
